export default {
    config: {
        defaultWidth: 80
    },
    default: {
        label: 'Play Worth'
    },
    unique: [],
    sort: 'worth.play',
    lang: {
        name: 'Average Play Worth',
        category: ['User', 'Plays'],
        description: 'The estimated value of a game divided by plays.',
        views: ['list', 'sheet', 'grid'],
    },
    filters: ['play.worth']
}